module.exports = __webpack_public_path__ + "static/media/paint.e42d8fd5.svg";